import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Button,
    Chip,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { addFilter, clearFilters, removeFilter } from '../../store/slices/insightsSlice';

const TagFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const tags = useAppSelector((state) => state.tags.items);
  const selectedFilters = useAppSelector((state) => state.insights.selectedFilters);

  const handleTagClick = (tagId: string) => {
    if (selectedFilters.includes(tagId)) {
      dispatch(removeFilter(tagId));
    } else {
      dispatch(addFilter(tagId));
    }
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <Box sx={{ mb: 4, p: 3, bgcolor: 'grey.50', borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <FilterListIcon sx={{ mr: 1 }} />
        <Typography variant="h6" component="h2">
          タグで絞り込み
        </Typography>
        {selectedFilters.length > 0 && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={handleClearFilters}
            sx={{ ml: 'auto' }}
          >
            すべてクリア
          </Button>
        )}
      </Box>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {tags.map((tag) => {
          const isSelected = selectedFilters.includes(tag.id);
          return (
            <Chip
              key={tag.id}
              label={tag.name}
              clickable
              variant={isSelected ? 'filled' : 'outlined'}
              onClick={() => handleTagClick(tag.id)}
              sx={{
                backgroundColor: isSelected ? tag.color : 'transparent',
                borderColor: tag.color,
                color: isSelected ? 'white' : tag.color,
                fontWeight: isSelected ? 'bold' : 'normal',
                '&:hover': {
                  backgroundColor: isSelected ? tag.color : tag.color + '20',
                  opacity: 0.8,
                },
                mb: 1,
              }}
            />
          );
        })}
      </Stack>

      {selectedFilters.length > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {selectedFilters.length} 個のタグでフィルタリング中
        </Typography>
      )}
    </Box>
  );
};

export default TagFilter;
